<template>
  <div class="container">
    <Loader v-if="isLoading" />
    <div class="row">
      <div class="col col-12 col-md-12 text-center">
        <div class="test-detail position-relative">
          <h4 class="mb-4">
            {{ test.question }}
          </h4>
          <div>
            <img
              :src="test.questionImage"
              class="test-detail-img"
              alt="Test Image"
            />
          </div>
        </div>
        <div class="test-detail-buttons text-center py-3">
          <a class="btn bg-primary text-light btn-lg mb-3" @click="goToTest()">
            <span class="mr-2" />{{ $t('test.start') }}
          </a>
        </div>
      </div>
    </div>
    <div><br /><br /></div>
    <div>{{ test.blogpost }}</div>
    <h3 class="mt-5 mb-3">
      {{ $t('test.recommended') }}
    </h3>
    <b-row>
      <b-col
        v-for="recommended in recommendedTests"
        :key="recommended._id"
        md="4"
        sm="6"
        class="mb-4"
      >
        <RouterLink
          :to="`/test/${recommended._id}`"
          class="test-link position-relative d-block"
        >
          <h6 class="text-light rounded m-4 p-2 test-link-img-title">
            {{ recommended.question }}
          </h6>
          <img :src="recommended.questionImage" class="test-img" alt="Image" />
        </RouterLink>
      </b-col>
    </b-row>

    <b-row class="mt-4 px-3">
      <h4>{{ $t(domainWithoutDot + '.brand') }}</h4>
      <h6>
        {{ $t(domainWithoutDot + '.about') }}
      </h6>
    </b-row>
  </div>
</template>

<script>
import Loader from '@/components/Loader';

import { mapGetters } from 'vuex';
import { API } from '@/services/';
import {
  API_BASE_URL,
  API_GET_TEST_BY_ID,
  API_GET_TESTS_BY_LANGUAGE,
} from '@/helpers/config';

const uuidv4 = require('uuid/v4');

export default {
  components: {
    Loader,
  },
  data: () => ({
    isLoading: true,
    test: [],
    recommendedTests: [],
    url: API_BASE_URL,
  }),
  computed: {
    ...mapGetters(['domainWithoutDot', 'region', 'country', 'gender']),
  },
  watch: {
    // if user wants to go another test detail page, fetch new page data
    // eslint-disable-next-line
    '$route.params.id': function () {
      this.isLoading = true;
      this.getPageData();
    },
  },
  created() {
    this.getPageData();
  },
  methods: {
    goToTest() {
      const src = this.$route.query.src;
      const city = this.$route.query.city;
      // this.$router.push(`/instagram?testId=${this.$route.params.id}`);
      this.$router.push(
        `/test/${
          this.$route.params.id
        }/start?id=${uuidv4()}&src=${src}&city=${city}`
      );
    },
    getTestDetail() {
      const url = API_GET_TEST_BY_ID + this.$route.params.id;
      return API.get(url);
    },
    getRecommendedTests() {
      // get tests by using selected locale (language code)
      const url = `${API_GET_TESTS_BY_LANGUAGE + this.$i18n.locale}?size=7`;
      return API.get(url);
    },
    getPageData() {
      Promise.all([this.getTestDetail(), this.getRecommendedTests()])
        .then((response) => {
          // scroll to top
          window.scrollTo(0, 0);
          this.test = response[0].data;

          // append og:image meta tag to head for facebook bot
          const meta = document.createElement('meta');
          meta.setAttribute('property', 'og:image');
          meta.setAttribute('content', this.test.questionImage);
          document.getElementsByTagName('head')[0].appendChild(meta);

          // set document title
          document.title = this.test.question;

          // remove test from recommendedTests if there is
          // eslint-disable-next-line
          this.recommendedTests = response[1].data.data.filter(
            (t) => t._id !== this.test._id
          );
          if (this.recommendedTests.length === 7) this.recommendedTests.pop();

          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.status === 204 || error.response.status === 400)
            this.$router.push('/404');
        });
    },
  },
};
</script>

<style>
.test-link-img-title {
  position: absolute;
  left: 0;
  top: 20px;
  background: rgba(0, 0, 0, 0.3);
}

.test-detail-img {
  width: 600px;
}

@media (max-width: 768px) {
  .test-detail-img {
    width: 100%;
  }
}

.sidebar-link {
  font-size: 0.8rem;
}

.test-detail-img-title {
  position: absolute;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
}
</style>
